import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, TextField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'

import type { Schema } from './schema'

export const EmployeeSettingsSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.kWords.employeeSettings',
  })
  const { control } = useFormContext<Schema>()

  const ability = useAbility()
  const cannotUpdate: boolean = ability.cannot(
    'update',
    'GlobalSetupFeature-defaults-richPlacements',
  )
  const cannotUpdateSiteId: boolean = ability.cannot('update', 'GlobalSetupField-kWordsSiteId')

  return (
    <Paper
      data-cy='section-employee-settings'
      variant='cream'
    >
      <BoxForm>
        <SectionHeader
          subtitle={t('subtitle')}
          title={t('title')}
        />

        <TextField
          control={control}
          disabled={cannotUpdate || cannotUpdateSiteId}
          label={t('label')}
          name='kwordsSiteId'
          tooltip={{ content: t('tooltip') }}
        />
      </BoxForm>
    </Paper>
  )
}
